import type { ReactNode } from 'react';
import { RecordPicker } from '../../components/RecordPicker.js';

interface LcncAppOption {
  readonly applicationId: string;
  readonly applicationCode: string;
  readonly applicationName: string;
}

interface Props {
  readonly label: string;
  readonly value: string;
  readonly onPick: (id: string, label: string) => void;
  readonly testId?: string;
}

/** Application chooser shared by the M28 low-code designer screens. */
export function LcncAppPicker({
  label,
  value,
  onPick,
  testId = 'field-application-id',
}: Props): ReactNode {
  return (
    <RecordPicker<LcncAppOption>
      endpoint="/v1/lcnc/applications?pageSize=500"
      idField="applicationId"
      label={label}
      testId={testId}
      value={value}
      optionLabel={(a) => `${a.applicationName} (${a.applicationCode})`}
      onPick={onPick}
      emptyText="No applications yet"
    />
  );
}
